
import { defineComponent } from 'vue';
import StationsMap from '@/components/Blocks/StationsMap.vue';
import useCabinetStore from '@/store/CabinetStore';

export default defineComponent({
  components: {
    StationsMap,
  },

  setup() {
    const { company } = useCabinetStore();
    return { company };
  },
});
